import { useState, useEffect, useCallback, useRef } from 'react';
import Formsy from 'formsy-react';

import { 
  Button, IconButton, Table, TableContainer, TableHead, TableBody, Paper, 
  DialogTitle, DialogContent, DialogContentText, DialogActions 
} from '@mui/material';
import { Edit } from '@mui/icons-material';

import { D, Loading, TRow, TCell, TextFieldFormsy } from '../include';

// ==========================================
// COMPONENTE de edição das configurações
// ==========================================
const EditSysConfig = ({ row, api, alert, dialogClose, onSuccess }) => {
  const [name, setName] = useState(row?.name || '');
  const [path, setPath] = useState(row?.path || '');

  const handleSave = () => {
    api.put('/PathList/' + row.id, { id: row.id, name, path })
      .then(r => {
        onSuccess();
        alert(r.message || "Configuração salva com sucesso!");
      })
      .catch(e => {
        alert(e.message || 'Ocorreu um erro ao salvar a configuração');
      });
  };

  return (
    <Formsy onValidSubmit={handleSave}>
      <DialogTitle>Editar configuração do sistema</DialogTitle>
      
      <DialogContent>
        <DialogContentText className="row w aC">
          Altere os parâmetros que desejar e clique em salvar
        </DialogContentText>
        <D h="2rem" />
        
        <TextFieldFormsy 
          type="text" name="name" label="Nome" required 
          value={name} onChange={v => setName(v)} 
        />
        <D h="1rem" />
        
        <TextFieldFormsy 
          type="text" name="path" label="Diretório" required 
          value={path} onChange={v => setPath(v)} 
        />
        <D h="2rem" />
      </DialogContent>
      
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={dialogClose}>
          Cancelar
        </Button>
        <Button variant="outlined" color="primary" type="submit">
          Salvar
        </Button>
      </DialogActions>
    </Formsy>
  );
};


// ==========================================
// COMPONENTE PRINCIPAL configurações do sistema
// ==========================================
export const SysConfig = ({ api, permission, dialog, dialogClose, alert }) => {
  const [pathData, setPathData] = useState(null); // null indica Loading
  
  // Ref para proteger contra a montagem dupla do React Strict Mode
  const isFirstRender = useRef(true);

  // Memoiza a função para não recriá-la a cada renderização
  const fetchPaths = useCallback(() => {
    setPathData(null); // Ativa o Loading visual
    api.get('/PathList')
      .then(r => setPathData(r))
      .catch(err => {
        console.error("Erro ao carregar configurações:", err);
        setPathData([]);
      });
  }, [api]);

  useEffect(() => {
    // Portão de segurança: a requisição só passa pela rede uma única vez
    if (isFirstRender.current) {
      isFirstRender.current = false;
      fetchPaths();
    }
  }, [fetchPaths]);

  return (
    <D className="col e aF scD" style={{ padding: '2rem' }}>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer style={{ height: '100%' }}>
          <Table stickyHeader>
            <TableHead>
              <TRow>
                {permission === 'w' && <TCell align="center" sx={{ width: '8ch' }}>Editar</TCell>}
                <TCell>Diretório</TCell>
                <TCell width="100%">Nome</TCell>
              </TRow>
            </TableHead>
            
            <TableBody>
              {pathData === null ? (
                // Estado de Carregamento
                <TRow>
                  <TCell component="th" align="center" colSpan={3}>
                    <Loading />
                  </TCell>
                </TRow>
              ) : pathData.length > 0 ? (
                // Tabela Renderizada
                pathData.map(row => (
                  <TRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    {permission === 'w' && (
                      <TCell align="center" component="th">
                        <IconButton 
                          style={{ color: '#aaa' }} 
                          onClick={() => dialog(
                            <EditSysConfig 
                              row={row} 
                              api={api} 
                              alert={alert} 
                              dialogClose={dialogClose} // Apenas fecha
                              onSuccess={() => { fetchPaths(); dialogClose(); }} // Recarrega e fecha
                            />
                          )}
                        >
                          <Edit />
                        </IconButton>
                      </TCell>
                    )}
                    <TCell component="th">{row.path}</TCell>
                    <TCell component="th">{row.name}</TCell>
                  </TRow>
                ))
              ) : (
                // Lista Vazia
                <TRow>
                  <TCell component="th" align="center" colSpan={3}>
                    Nenhuma configuração encontrada
                  </TCell>
                </TRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </D>
  );
};